<template>
  <div class="teaching-score-input-handle">
    <div class="header">
      <NavBar :title="barTitle"
              border
              @back="hidePopover">
        <template #extra>
          <div v-if="isReady"
               class="extra">
            <el-button size="mini"
                       type="default"
                       :disabled="committing"
                       @click="handleSave">暂存成绩</el-button>
            <el-button size="mini"
                       type="primary"
                       :disabled="committing"
                       @click="handleCommit">提交成绩</el-button>
          </div>
        </template>
      </NavBar>
    </div>
    <div class="main">
      <div class="main-cont"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <PrepareLayout prepare-url="/workspace/manager/teaching/score/input/schedule/state"
                       :prepare-params="handleParams"
                       :prepare-active="visible">
          <TeachingScoreInputHandleMain ref="main"
                                        :visible="visible"
                                        v-bind="handleParams"
                                        v-on="$listeners"
                                        @ready="handleReady"
                                        @config-success="onConfigSuccess"></TeachingScoreInputHandleMain>
        </PrepareLayout>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '../../../../../../../widgets/NavBar'
import PrepareLayout from '../../../../../../../widgets/custom/PrepareLayout'
import TeachingScoreInputHandleMain from './main'
export default {
  name: 'TeachingScoreInputHandle',
  components: {
    NavBar,
    PrepareLayout,
    TeachingScoreInputHandleMain
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      isReady: false,
      committing: false
    }
  },
  computed: {
    barTitle () {
      return `${this.rowData.semesterName} - ${this.rowData.className} - ${this.rowData.siteName} - ${this.rowData.courseName}`
    },
    handleParams () {
      return {
        scheduleId: this.rowData.id
      }
    }
  },
  methods: {
    hidePopover () {
      this.$emit('hidePopover')
    },
    handleReady () {
      this.isReady = true
    },
    handleSave () {
      let main = this.$refs.main
      if (main) {
        main.handleElectives()
          .then(electives => {
            this.committing = true
            this.$ajax({
              url: '/workspace/manager/teaching/score/input/schedule/scoreSave',
              method: 'post',
              data: this.$qs.stringify(this.$extend({
                inputScore: JSON.stringify({electives})
              }, this.handleParams))
            }).then(response => {
              if (response.data) {
                switch (response.data['responseCode']) {
                  case 'SUCCESS': {
                    this.$message.success(response.data['message'])
                    this.$nextTick(() => {
                      this.$emit('reloadGridData')
                    })
                    break
                  }
                  default: {
                    this.$message.warning(response.data['message'])
                    break
                  }
                }
              }
            }, () => {
              this.$message.error('请求发送失败，请稍后重试')
            }).finally(() => {
              this.committing = false
            })
          }).catch(err => {
            this.$message.warning(err.message)
          })
      }
    },
    handleCommit () {
      let main = this.$refs.main
      if (main) {
        main.handleElectives(true)
          .then(electives => {
            this.$confirm('确定要提交已录入的成绩吗？成绩提交后将不能再修改！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.committing = true
              this.$ajax({
                url: '/workspace/manager/teaching/score/input/schedule/scoreCommit',
                method: 'post',
                data: this.$qs.stringify(this.$extend({
                  inputScore: JSON.stringify({electives})
                }, this.handleParams))
              }).then(response => {
                if (response.data) {
                  switch (response.data['responseCode']) {
                    case 'SUCCESS': {
                      this.$message.success(response.data['message'])
                      this.$nextTick(() => {
                        this.$emit('hidePopoverAndRefresh')
                      })
                      break
                    }
                    default: {
                      this.$message.warning(response.data['message'])
                      break
                    }
                  }
                }
              }, () => {
                this.$message.error('请求发送失败，请稍后重试')
              }).finally(() => {
                this.committing = false
              })
            }).catch(() => {})
          }).catch(err => {
            this.$message.warning(err.message)
          })
      }
    },
    onConfigSuccess () {
      this.$emit('reloadGridData')
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-input-handle {
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      .extra {
        .el-button {
          padding: 6px 15px;
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
